import HigSideNav from '@hig/side-nav';
const Module = HigSideNav.Module;

export default Module;
